var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-24" }, [
    _c(
      "div",
      { staticClass: "el-card p-16 params-item" },
      [
        _c("el-cascader", {
          ref: "areaDropdown",
          staticClass: "fx-none",
          attrs: {
            placeholder: "全国",
            "show-all-levels": false,
            clearable: "",
            options: _vm.selectArea,
            "collapse-tags": "",
            props: {
              multiple: true,
              children: "childOption",
              checkStrictly: false,
              emitPath: false,
            },
          },
          model: {
            value: _vm.areaValue,
            callback: function ($$v) {
              _vm.areaValue = $$v
            },
            expression: "areaValue",
          },
        }),
        _c("el-date-picker", {
          ref: "dataPicker",
          staticStyle: { width: "280px" },
          attrs: {
            type: "daterange",
            align: "right",
            "unlink-panels": "",
            "value-format": "yyyy-MM-dd",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "picker-options": _vm.pickerOptions,
            clearable: false,
          },
          model: {
            value: _vm.time,
            callback: function ($$v) {
              _vm.time = $$v
            },
            expression: "time",
          },
        }),
        _c(
          "el-select",
          {
            attrs: {
              filterable: "",
              multiple: "",
              clearable: "",
              placeholder: "请输入搜索关键词",
              remote: "",
              "remote-method": _vm.remoteMethod2,
            },
            model: {
              value: _vm.keywordList,
              callback: function ($$v) {
                _vm.keywordList = $$v
              },
              expression: "keywordList",
            },
          },
          _vm._l(_vm.keywordOptions, function (item) {
            return _c("el-option", {
              key: item,
              attrs: { label: item, value: item },
            })
          }),
          1
        ),
        _c(
          "el-select",
          {
            attrs: {
              filterable: "",
              clearable: "",
              placeholder: "请输入机构名称",
              remote: "",
              "remote-method": _vm.remoteMethod,
            },
            model: {
              value: _vm.organizationVal,
              callback: function ($$v) {
                _vm.organizationVal = $$v
              },
              expression: "organizationVal",
            },
          },
          _vm._l(_vm.organizationOptions, function (item) {
            return _c("el-option", {
              key: item,
              attrs: { label: item, value: item },
            })
          }),
          1
        ),
        _c(
          "el-select",
          {
            attrs: {
              filterable: "",
              multiple: "",
              clearable: "",
              placeholder: "请输入政策类型",
            },
            model: {
              value: _vm.policyType,
              callback: function ($$v) {
                _vm.policyType = $$v
              },
              expression: "policyType",
            },
          },
          _vm._l(_vm.policyOptions, function (item) {
            return _c("el-option", {
              key: item,
              attrs: { label: item, value: item },
            })
          }),
          1
        ),
        _c(
          "el-button",
          { staticClass: "mr-16 mb-16", on: { click: _vm.resetHandle } },
          [_vm._v("重置")]
        ),
        _c(
          "el-button",
          {
            staticClass: "ml-0 mb-16",
            attrs: { type: "primary" },
            on: { click: _vm.searchHandle },
          },
          [_vm._v("查询")]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "fx mt-24 pb-16" }, [
      _c("div", { staticClass: "el-card fx-full p-16" }, [
        _c(
          "div",
          { staticClass: "fx mb-16" },
          [
            _c("div", { staticClass: "fx-full" }),
            _c(
              "el-radio-group",
              {
                staticClass: "fx-none",
                attrs: { size: "mini" },
                on: { change: _vm.radioHandle },
                model: {
                  value: _vm.radio1,
                  callback: function ($$v) {
                    _vm.radio1 = $$v
                  },
                  expression: "radio1",
                },
              },
              [
                _c("el-radio-button", { attrs: { label: "1" } }, [
                  _vm._v("匹配度顺序"),
                ]),
                _c("el-radio-button", { attrs: { label: "2" } }, [
                  _vm._v("按时间排序"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "fx-full el-card pl-16" },
          [
            _c(
              "el-scrollbar",
              {
                ref: "scrollbar",
                staticStyle: { height: "684px" },
                attrs: {
                  "wrap-class": "scrollbar-wrapper scrollbar-wrapper-maxheight",
                },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "infinite-scroll",
                        rawName: "v-infinite-scroll",
                        value: _vm.load,
                        expression: "load",
                      },
                    ],
                    key: _vm.scrollKey,
                    staticClass: "mr-16",
                    attrs: { "infinite-scroll-disabled": "disabled" },
                  },
                  [
                    _vm._l(_vm.policyList, function (item, i) {
                      return _c("TextDocument", {
                        key: i,
                        attrs: { data: item, showTag: true },
                      })
                    }),
                    _vm.loading
                      ? _c("p", { staticClass: "textAline" }, [
                          _vm._v("加载中..."),
                        ])
                      : _vm._e(),
                    _vm.policyList.length && _vm.noMore
                      ? _c("p", { staticClass: "textAline" }, [
                          _vm._v("- 没有更多了 -"),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                !_vm.policyList.length && !_vm.loading
                  ? _c("EmptyBox")
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "ml-24 fx-none", staticStyle: { width: "500px" } },
        [
          _c(
            "div",
            { staticClass: "el-card p-16 mb-24" },
            [
              _c("MyTitle", { staticClass: "mb-16" }, [_vm._v(" 政策高频词 ")]),
              _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.tableData, "max-height": "300" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "政策高频词",
                          width: "180",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "相关政策数量" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c("el-progress", {
                                  attrs: {
                                    percentage: row.percentage,
                                    format: function (p) {
                                      return _vm.format(row)
                                    },
                                    "stroke-width": 8,
                                    color: "#186bfc",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "el-card p-16" },
            [
              _c("MyTitle", { staticClass: "mb-16" }, [
                _vm._v(" 政策区域分布 "),
              ]),
              _c("MyEcharts", {
                ref: "chartFirst",
                staticStyle: { width: "100%", height: "300px" },
              }),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }